import {ApplicationConfig, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, withRouterConfig} from '@angular/router';
import {routes} from './app.routes';
import {SessionService} from "./services/session.service";
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";

export const appConfig:ApplicationConfig = {
	providers: [
		provideRouter(routes, withRouterConfig({paramsInheritanceStrategy: 'always'})),
		provideZoneChangeDetection({eventCoalescing: true}),
		provideHttpClient(withInterceptorsFromDi()),

		//add session service and interceptors for handling logging in / out and maintaining session
		SessionService,
		{provide: HTTP_INTERCEPTORS, useExisting: SessionService, multi: true}
	]
};
